import Select from "ol/interaction/Select";
import { click, pointerMove } from "ol/events/condition";
import {
  getRmRoadClassStyleClick,
  getRmRoadClassStyleHover,
  getRmWireStyleClick,
  getRmWireStyleHover,
} from "../style/rmRoadClass";

export function getRmRoadClassInteractions(layer, control) {
  return getInteractions(
    layer,
    control,
    getRmRoadClassStyleClick,
    getRmRoadClassStyleHover,
  );
}

export function getRmWireInteractions(layer, control) {
  return getInteractions(
    layer,
    control,
    getRmWireStyleClick,
    getRmWireStyleHover,
  );
}

function getInteractions(layer, control, clickStyle, hoverStyle) {
  const clickSelect = new Select({
    layers: [layer],
    condition: click,
    style: clickStyle,
  });
  clickSelect.on("select", function (e) {
    if (e.target.getFeatures().getLength() > 0) {
      control.set(
        "selectedFeatures",
        Array.from(e.target.getFeatures().getArray()),
      ); // create new array so that the event gets triggered
    } else {
      control.set("selectedFeatures", undefined);
    }
  });
  return [
    clickSelect,
    new Select({
      layers: [layer],
      condition: pointerMove,
      style: hoverStyle,
    }),
  ];
}
